




import { Vue, Component } from "vue-property-decorator";
import { MsgTransports } from "@/store/types";
import DetailIncoming from "@/pages/Pages/Statistics/DetailIncoming.vue";

@Component({ components: { DetailIncoming } })
export default class ViberDetailIncoming extends Vue {
  private transport: MsgTransports = MsgTransports.WHATSAPP;
}
